export default __webpack_public_path__ + "img/efb800a087a2bb7c0250ef564979d750.png";